import React, { useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import { Button, Dialog, TextField, InputAdornment } from "@mui/material";
// import { ReactComponent as Close } from "../assets/svg/Close.svg";
// import { ReactComponent as Close } from "../assets/svg/Close.svg";
// import { ReactComponent as Refresh } from "../assets/svg/refresh.svg";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";
import "../../../Assets/css/kyc.css";
import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useLocation, useNavigate } from "react-router-dom";

const VerifyResidentialForm = () => {
  const numOfContainers = 6;
  // const [open, setOpen] = useState(false);
  const navigation = useNavigate();
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const location = useLocation();
  const { documentType } = location.state || {};
  const [proof, setProof] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setcountry] = useState("");
  const [postal, setpostal] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState();
  const [verify, setVerify] = useState(false);
  const [show, setShow] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Set dragging state
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files; // Access dropped files
    handleFileChange({ target: { files } }); // Pass files to the handler
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Only handle one file
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Set the image preview to the FileReader result
      };
      reader.readAsDataURL(file);
      console.log("Image preview", imagePreview);
      // Read the file as a data URL for preview
    } else {
      console.log("Please upload a valid image file.");
    }
  };

  const navigate = useNavigate();
  const documentLabels = {
    10: "Electricity Bills",
    20: "Water Bills",
    30: "Gas Bills",
    40: "Rental Agreement",
    50: "Bank Statement",
  };
  const inputRefs = useRef([]); // Create an array of refs for each text field

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    // setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
    setShow(true);
  };

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");

  return (
    <>
      <div className="Allcards_full_container p-2">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your Residential Address Identity</h2>
            {showData ? (
              <p className="paragraph m-0">
                Upload Your Residential Address for Secure Verification
              </p>
            ) : (
              <p className="paragraph m-0">
                Your Residential Address has been Verified Successfully.
              </p>
            )}
            <TextField
              label="Address Proof*"
              value={documentLabels[documentType] || ""}
              className="m-4"
              style={{ width: "400px" }}
              InputProps={{
                readOnly: true, // Make the TextField read-only
              }}
            />

            <div className="d-flex justify-content-center">
              <div>
                {!fileURL && (
                  <>
                    {imagePreview ? (
                      ""
                    ) : (
                      <>
                        <div
                          //   className={`file-upload-container ${
                          //     isDragging ? "dragging" : ""
                          //   }`}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            id="file-input"
                          />

                          <label
                            htmlFor="file-input"
                            className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3"
                          >
                            <Cloud width={80} />
                            <span className="m-0 p-0">
                              {isDragging
                                ? "Drop file here"
                                : "Drag file here or "}
                              <span className="text-primary">Upload File</span>
                            </span>
                            <p>5MB max file size</p>
                          </label>
                        </div>
                      </>
                    )}

                    {imagePreview && (
                      <div className="selectedImage">
                        <img
                          src={imagePreview}
                          alt="Uploaded"
                          style={{ maxWidth: "300px", marginTop: "20px" }}
                        />
                      </div>
                    )}
                  </>
                )}

                {fileURL && (
                  <div className="selectedImage">
                    {file && file.type.startsWith("image/") && (
                      <img
                        src={fileURL}
                        alt="Selected"
                        style={{
                          marginTop: "10px",
                          // maxWidth: "300px",
                          // maxHeight: "300px",
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    {file && file.type === "application/pdf" && (
                      <iframe
                        src={fileURL}
                        title="Selected PDF"
                        style={{
                          marginTop: "10px",
                          width: "100%",
                          height: "500px",
                        }}
                      />
                    )}
                  </div>
                )}
                {file && file.type === "application/pdf" && (
                  <iframe
                    className="button d-flex flex-column align-items-center justify-content-center m-3"
                    src={fileURL}
                    title="Selected PDF"
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      height: "500px",
                    }}
                  />
                )}
              </div>
              {!imagePreview && (
                <>
                  <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                    <Takephoto />
                    <p className="custom-text-color text-capitalize">
                      Capture Image
                    </p>
                  </Button>
                </>
              )}
            </div>

            {showData ? (
              <p className="paragraph ">
                Please upload a clear image of your Electricity Bill to begin
                the verification process. Our system will automatically
                <br /> detect and display your details. Alternatively, you can
                manually enter the details below.
              </p>
            ) : (
              ""
            )}
            {show && (
              //   <div className="d-flex flex-row align-items-center">
              //     <TextField
              //       label={"Current Proof*"}
              //       value={proof}
              //       onChange={(e) => setProof(e.target.value)}
              //       className="m-4"
              //       style={{ width: "400px" }}
              //     />
              //     <br />
              //     <div className="verify d-flex align-items-center">
              //       {verify ? <Verify /> : <NonVerify />}
              //     </div>
              //   </div>
              <TextField
                label={"Current Proof*"}
                value={proof}
                onChange={(e) => setProof(e.target.value)}
                className="m-4"
                style={{ width: "400px" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {verify ? <Verify /> : <NonVerify />}
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {!showData ? (
              <p className="paragraph">
                Thank You for Verifying Your Resident Address Proof. Your
                identity has been securely confirmed. You can now
                <br /> proceed to the next steps or return to your dashboard to
                explore other features.
              </p>
            ) : (
              ""
            )}

            {showData ? (
              <>
                {documentLabels[documentType] === "Bank Statement" && (
                  <TextField
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    label={"Bank Name*"}
                    className="m-2"
                    style={{ width: "400px" }}
                  />
                )}

                {documentLabels[documentType] === "Rental Agreement" && (
                  <>
                    <h4>Tenant Information</h4>
                    <TextField
                      label={"Certificate Number*"}
                      className="m-2"
                      style={{ width: "400px" }}
                    />
                  </>
                )}
                {(documentLabels[documentType] === "Rental Agreement" ||
                  documentLabels[documentType] === "Bank Statement") && (
                  <>
                    <TextField
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      label={"Phome Number*"}
                      placeholder="+91"
                      className="m-2"
                      style={{ width: "400px" }}
                    />

                    <TextField
                      value={currentAddress}
                      onChange={(e) => setCurrentAddress(e.target.value)}
                      label={"Current Address*"}
                      className="m-2"
                      style={{ width: "400px" }}
                    />
                  </>
                )}

                {(documentLabels[documentType] === "Electricity Bills" ||
                  documentLabels[documentType] === "Bank Statement") && (
                  <TextField
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    label={"Account Number*"}
                    className="m-2"
                    style={{ width: "400px" }}
                  />
                )}

                {(documentLabels[documentType] === "Electricity Bills" ||
                  documentLabels[documentType] === "Water Bills" ||
                  documentLabels[documentType] === "Gas Bills") && (
                  <TextField
                    label={"Issue Authority*"}
                    className="m-2"
                    style={{ width: "400px" }}
                  />
                )}

                {(documentLabels[documentType] === "Water Bills" ||
                  documentLabels[documentType] === "Gas Bills") && (
                  <TextField
                    label={"Consumer ID*"}
                    className="m-2"
                    style={{ width: "400px" }}
                  />
                )}

                <TextField
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  label={"Full Name*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={currentAddress}
                  onChange={(e) => setCurrentAddress(e.target.value)}
                  label={"Street Address*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  label={"City/Town*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  label={"State/Province*"}
                  style={{ width: "400px" }}
                  className="m-2"
                  id="captchaInput"
                />
                <TextField
                  value={postal}
                  onChange={(e) => setpostal(e.target.value)}
                  label={"Postal/ZIP Code*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={country}
                  onChange={(e) => setcountry(e.target.value)}
                  label={"Country*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                {documentLabels[documentType] === "Rental Agreement" && (
                  <>
                    <h4>Landlord Information</h4>
                    <TextField
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      label={"Full Name*"}
                      className="m-2"
                      style={{ width: "400px" }}
                    />
                    <TextField
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      label={"Phome Number*"}
                      placeholder="+91"
                      className="m-2"
                      style={{ width: "400px" }}
                    />
                    <TextField
                      type="date"
                      label={"start Date"}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      //   label={"Start Date*"}
                      className="m-2"
                      style={{ width: "400px" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      type="date"
                      label={"End Date"}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      //   label={"End Date*"}
                      className="m-2"
                      style={{ width: "400px" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </>
                )}
              </>
            ) : (
              ""
            )}
            {showData ? (
              <>
                <div className="d-flex flex-row">
                  <Button
                    // variant="contained"
                    className="txtcolor mt-2 "
                    //   onClick={() => setOpen(true)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="btncolor mt-2"
                    onClick={() => setVerifiedOpen(true)}
                  >
                    Confirm
                  </Button>
                </div>
              </>
            ) : (
              <Button
                variant="contained"
                className="btncolor mt-2"
                onClick={() =>
                  navigate("/countrySelecting", {
                    state: {
                      SelectedCountry: {
                        label: "India",
                        code: "IN",
                        phone: "91",
                      },
                    }, // Pass the selected country object
                  })
                }
              >
                Back to KYC
              </Button>
            )}

            <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
              <div>
                <div className=" my-2 mx-5 p-2 align-items-center justify-content-center text-center">
                  <Successmsg />
                  <div className="align-items-center justify-content-center text-center">
                    <h6 className="fw-bold">Verification Successful!</h6>
                    <p>Your Passport Details has been successfully verified.</p>
                  </div>
                </div>
                <div className=" d-flex justify-content-center m-3 align-items-center">
                  <Button
                    variant="contained"
                    className="btncolor"
                    onClick={() => handleClose()}
                  >
                    continue
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyResidentialForm;
